export default "__VITE_ASSET__268efee9__"